import { Box } from 'rebass'

import { PageHeader } from '../shared/PageHeader'
import { ProcessFlow } from '../shared/stepper/processFlowIndicator'

type IdentityDisplayProps = {
  children: React.ReactNode
}

const IdentityDisplay = ({ children }: IdentityDisplayProps) => (
  <Box width={[1, 15.6 / 16]} >
    <ProcessFlow active="identity" />
    <PageHeader />
    {children}
  </Box>
)

export { IdentityDisplay }
